import { useEffect, useState } from "react";
import client from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { AssistantWidget } from "@/components/AssistantWidget";

const LAYOUTS = {
  comms: { label: "Communications Center", keys: ["calls_waiting", "longest_wait_sec", "p1", "p2", "units_available", "units_assigned", "units_on_scene", "multimedia_sessions"] },
  supervisor: { label: "CAD Supervisor", keys: ["calls_waiting", "p1", "active_total", "units_available", "units_oos", "overdue_reports", "multimedia_sessions", "integration_failures"] },
  executive: { label: "Executive Command", keys: ["active_total", "p1", "p2", "units_available", "units_on_scene", "system_health"] },
  rtoc: { label: "Real-Time Operations", keys: ["active_total", "p1", "calls_waiting", "units_on_scene", "multimedia_sessions", "longest_wait_sec"] },
  eoc: { label: "Emergency Operations", keys: ["active_total", "p1", "p2", "units_available", "units_oos", "system_health", "integration_failures", "calls_waiting"] },
  training: { label: "Training Room", keys: ["calls_waiting", "active_total", "units_available", "system_health"] },
};
const LBL = { calls_waiting: "CALLS WAITING", longest_wait_sec: "LONGEST WAIT", p1: "PRIORITY 1", p2: "PRIORITY 2",
  active_total: "ACTIVE INCIDENTS", units_available: "UNITS AVAILABLE", units_assigned: "UNITS ASSIGNED",
  units_on_scene: "ON SCENE", units_oos: "OUT OF SERVICE", multimedia_sessions: "MULTIMEDIA SESSIONS",
  overdue_reports: "OVERDUE REPORTS", integration_failures: "INTEGRATION FAILURES", system_health: "SYSTEM HEALTH" };
const fmtSec = (s) => (s >= 60 ? `${Math.floor(s / 60)}m` : `${s}s`);

export default function Wallboard() {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [layout, setLayout] = useState(localStorage.getItem("wb-layout") || "comms");
  const load = () => client.get("/wallboard").then((r) => setD(r.data)).catch((e) => setD({ err: e.response?.data?.detail || "Unavailable" }));
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, []);
  const val = (k) => {
    if (!d) return "—";
    if (k === "longest_wait_sec") return fmtSec(d[k] || 0);
    return d[k] ?? "—";
  };
  const color = (k) => {
    if (k === "p1" && d?.p1 > 0) return "#EF4444";
    if (k === "calls_waiting" && d?.calls_waiting > 5) return "#F59E0B";
    if (k === "system_health") return "#10B981";
    if (k === "units_available") return "#10B981";
    return "#F3F4F6";
  };
  if (d?.err) return <div className="min-h-screen bg-[#0d0e11] text-[#F59E0B] flex items-center justify-center font-mono">{d.err} — enable Wallboard in Add-On Manager.</div>;
  return (
    <div className="min-h-screen bg-[#0d0e11] text-white p-6" data-testid="wallboard">
      <div className="flex items-center gap-3 mb-6 flex-wrap">
        <button onClick={() => nav(-1)} className="font-mono text-[11px] text-[#9CA3AF] hover:text-white">← BACK</button>
        <div className="font-head text-xl font-bold tracking-widest">MATCOM COMMUNICATIONS WALLBOARD</div>
        <span className="font-mono text-[10px] text-[#6B7280]">{d?.ts?.slice(11, 19)} UTC · auto-refresh 5s</span>
        <div className="ml-auto flex gap-1.5 flex-wrap">
          {Object.entries(LAYOUTS).map(([k, v]) => (
            <button key={k} data-testid={`wb-layout-${k}`} onClick={() => { setLayout(k); localStorage.setItem("wb-layout", k); }}
              className={`px-3 py-1.5 text-[10px] font-head font-bold rounded-sm border ${layout === k ? "bg-[#22D3EE] text-black border-[#22D3EE]" : "border-[#2C2D35] text-[#9CA3AF]"}`}>{v.label}</button>))}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {LAYOUTS[layout].keys.map((k) => (
          <div key={k} className="border border-[#2C2D35] bg-[#141518] rounded-sm p-6 text-center">
            <div className="font-mono text-xs text-[#9CA3AF] tracking-widest mb-3">{LBL[k]}</div>
            <div className="font-head font-bold" style={{ fontSize: 56, lineHeight: 1, color: color(k) }} data-testid={`wb-${k}`}>{val(k)}</div>
          </div>))}
      </div>
      {d?.zones && (
        <div className="mt-6 border border-[#2C2D35] bg-[#141518] rounded-sm p-4">
          <div className="font-mono text-xs text-[#9CA3AF] tracking-widest mb-2">INCIDENTS BY ZONE</div>
          <div className="flex gap-6 flex-wrap">
            {Object.entries(d.zones).map(([z, n]) => (
              <div key={z} className="font-mono text-sm"><span className="text-[#22D3EE] font-bold text-2xl mr-2">{n}</span>{z}</div>))}
          </div>
        </div>)}
      <AssistantWidget />
    </div>
  );
}
